$.fn.wizard = (function () {
    var Wizard = function (el, config) {
        this.el = $(el);
        $.extend(this, { // these defaults are overrideable
            // step selectors
            submitSelector: '.submit',
            stepSelector: '.step',
            movePrevious: '.previous',
            exitSelector: '.cancel',

            currentStep: 0,
            currentStepIsOptional: false,

            // messages
            loader: '<img class="loader" src="https://assets.orb.alkamitech.com/production/assets/global/images/loader-small.gif" width="15" height="15" style="margin-left: 5px; margin-bottom: -4px;" alt="Loading" />',
            exitMessage: Alkami.Localization.SiteText['Registration.Wizard.Quit.AreYouSure'],
            // steps
            steps: [],
            optionalSteps: [{
                name: 'error',
                request: '/Registration/Error'
            }, {
                name: 'resendPassword',
                request: '/Registration/CreateLogin?view=ResendPassword',
                submitAction: 'ajax',
                stepIndex: 0,
                callback: function () {
                    window.location.href = '/Authentication/Password';
                }                              
            }],

            onExit: function () {
                this.keepQuiet();
                if (navigator.userAgent.includes('NATIVEAPP')) {
                    location.href = '/Mobile/Authentication';
                } else {
                    location.href = '/';
                }
            },
            keepQuiet: function () {
                $(window).off('beforeunload.wizard');
            }
        }, config);


        this.config = config;
        this.bind();
        this.init();
    };

    var maskedCardNames = ['CreditCardNumber', 'DebitCardNumber'];

    var maskFormCards = function (formData) {

        $.each(formData, function(index, data) {

            if (maskedCardNames.indexOf(data.name) !== -1) {
                formData.splice(index, 1, { name: data.name, value: maskCard(data.value) });
            }
        });

        return formData;
    };

    Wizard.prototype = {
        shouldMaskCard: false,
        bind: function () {
            var self = this;
            this.el.on('click', this.submitSelector, function (e) {
                var item = $(this).parents(self.stepSelector);
                return self.submit(item, e);
            });

            this.el.on('click', this.exitSelector, function (e) {
                self.exit(e);
                return false;
            });
            this.el.on('click', this.movePrevious, function (e) {
                var prevIndex = self._movePrev();
                self.load(prevIndex);
                return false;
            });

            if (self.exitMessage !== false)
                $(window).on('beforeunload.wizard', function () {
                    return self.exitMessage;
                });
        },
        init: function () {
            // flag optional as optional
            for (var i = 0; i < this.optionalSteps.length; i++) {
                this.optionalSteps[i].optional = true;
            }

            if (this.el.html().trim() === '' || this.currentStep != 0) {
                this.load(this.currentStep);
            }
            else {
                this.afterStep.call(this);
            }
        },
        exit: function (e) {
            var self = this;

            if (self.exitMessage === false) {
                self.onExit.call(self);
                return;
            }

            var confirm = new Ext.Alkami.YesNoDialog({
                html: self.exitMessage,
                id: 'no-conflict',
                ajaxOptions: {
                    'yes': function () {
                        self.onExit.call(self);
                    },
                    'no': function () {
                        // return focus back to previously focused button
                        e.target.focus();
                    }
                },
                listeners: {
                    'afterrender': function () {
                        var $modal = $('#no-conflict');

                        $modal.attr({ 
                            tabindex: -1,
                            role: 'dialog',
                            'aria-labelledby': this.header.id,
                            'aria-describedby': this.body.id,
                            'aria-modal': true 
                        });

                        setTimeout(function() {
                            // set initial focus to the yes button 
                            $modal.find('.x-toolbar-cell:eq(1) button').focus();
                        }, 100);
                    }
                }
            });

            var $modal = $('#no-conflict');
            var focusableEls = $modal.find('button:not([disabled])');
            var firstFocusableEl = focusableEls[0];
            var lastFocusableEl = focusableEls[focusableEls.length - 1];

            $modal.on('keydown', function(e) {
                // Close modal
                if (e.key === 'Escape') {
                    confirm.close();
                    confirm.ajaxOptions.no.call()
                    return;
                }

                // trap focus in modal
                if (e.key !== 'Tab') { 
                    return; 
                }

                if (e.shiftKey) { // shift + tab
                    if (document.activeElement === firstFocusableEl) {
                        e.preventDefault();
                        lastFocusableEl.focus();
                    }
                } else { // tab
                    if (document.activeElement === lastFocusableEl) {
                        e.preventDefault();
                        firstFocusableEl.focus();
                    }
                }
            });
        },
        load: function (stepLocator, params) {
            var step = this._getStep(stepLocator), self = this;

            var serialize = function (obj) {
                var str = [];
                for (var p in obj)
                    if (obj.hasOwnProperty(p)) {
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    }
                return str.join("&");
            };

            var url = step.request;
            if (params)
                url += "?" + serialize(params);

            this.el.load(url, function () {
                if (self._handleLoadError.apply(self, arguments)) return;
                self.toggleLoader(false);
                self.afterStep.call(self);

                window.scrollTo(0, 0);

                if (step.onLoad)
                    step.onLoad.call(self, step);
                
                // last step remove unload
                if (self.currentStep === (self.steps.length - 1))
                    $(window).off('beforeunload.wizard');
            });

            if (self.progressBar) {
                self.progressBar.call(self);
            }
        },
        submit: function (item, e) {
            var form = item.is('form') ? item : item.find('form'),
                data = form.serializeArray(), //.serializeHash({ checkboxesAsBools: true }),
                self = this;

            // default the step
            var step = this.steps[this.currentStep];

            // if it is optional, find the matching optional step by the first matching stepIndex
            if (this.currentStepIsOptional) {
                var found = false;
                $.each(this.optionalSteps, function (index, value) {
                    if (self.currentStep == value.stepIndex && !found) {
                        step = value;
                        found = true;
                    }
                });
            }

            // Remove the error div on initial submit //
            this.toggleErrorDiv(false);

            // (re)validate form
            if (form.data('validator') && !form.valid()) { this.toggleErrorDiv(true); return; }

            this.toggleLoader(true);

            if (this.shouldMaskCard) {
                data = maskFormCards(data);
            }

            if (step.submitAction === 'ajax') {

                var paramData = jQuery.param(data);

                $.post(form[0].action, paramData)
                    .done(function (res) {
                        $.clearErrors(); // Remove error field class
                        Ext.Alkami.handleFormResponse(res, { form: form }, self);

                        // Places focus on the top most error so that the user doesn't have to shift tab back up the list. 
                        if (self.steps instanceof Array && self.steps.length > 0 && self.steps[self.steps.length -1].request.includes('Mobile/ForgotUsername') &&
                            res.errors && res.errors instanceof Array) {
                            var els = [];
                            res.errors.forEach((err) => {
                                var el;
                                switch(err){
                                    case 'DateOfBirth':
                                        el = $('#DateOfBirthDate');
                                        break;
                                    case '':
                                        return;
                                    default:
                                        el = $('#' + err);
                                        break;
                                }
                                els.push({
                                    el: el,
                                    offset: el.offset().top
                                })
                            });

                            if (els.length == 0) return;

                            var topEl = els.reduce((prev, curr) => {
                                if(prev.offset < curr.offset)
                                    return prev;
                                return curr;
                            });
                            topEl.el.focus();
                        }
                    }).fail(function (res) {
                        $.clearErrors(); // Remove error field class

                        //Cloudflare may return a 429 for rate limiting.  Pick up that return response, check for a valid SiteText key,  then display the appropriate error
                        if (res && res.responseJSON && res.responseJSON.errors instanceof Array && res.responseJSON.errors.length > 0 && Alkami.Localization.SiteText[res.responseJSON.errors[0]] != null) {
                            res.responseJSON.error_messages = [Alkami.Localization.SiteText[res.responseJSON.errors[0]]];
                            res.responseJSON.errors = [''];
                            Ext.Alkami.handleFormResponse(res.responseJSON, { form: form }, self);
                        }
                        else {
                            Ext.Alkami.handleFormResponse(res.responseText, { form: form }, self);
                        }
                    });
                return false;
            } else if (step.submitAction === 'form') {
                form.submit();
                return true;
            } else {
                return step.submitFn && step.submitFn.call(this, form, step);
            }
        },
        exception: function (res, showFlash) {
            if (showFlash !== false)
                Alkami.FlashBanner.showError(Alkami.Localization.SiteText.RegistrationShowFlashErrorOops);
            this.toggleLoader(false);
            this.toggleErrorDiv(false);
        },
        error: function (res) {
            this.toggleLoader(false);
            this.toggleErrorDiv(true);
            return true;
        },
        success: function (result) {
            if (result === true) { // pass back true to keep going

                // default the step
                var step = this.steps[this.currentStep];
                var self = this;

                // if it is optional, find the matching optional step by the first matching stepIndex
                if (this.currentStepIsOptional) {
                    var found = false;
                    $.each(this.optionalSteps, function (index, value) {
                        if (self.currentStep == value.stepIndex && !found) {
                            step = value;
                            found = true;
                        }
                    });
                }

                if (step.hasOwnProperty('callback')) {
                    step.callback.call(null);
                } else {
                    var next = this._moveNext();
                    this.load(next);
                }
            }
            else if (result === false) { // uh oh, error out
                this.load('error');
            }
        },
        toggleLoader: function (show, e) {
            var buttons = this.el.find('.buttons input'),
                form = this.el.find('form'),
                save = buttons.filter(this.submitSelector),
                cancel = buttons.filter('.cancel');
            if (show) {
                form.disableSubmit(Alkami.Localization.SiteText.RegistrationLoadSubmitPleaseWait);
                cancel.hide();
            }
            else {
                cancel.show();
                form.enableSubmit();
            }
        },
        toggleErrorDiv: function (show, e) {
            if (show) {
                this.el.find('div.errors.icon').show();
            }
            else {
                this.el.find('div.errors.icon').hide();
            }
        },
        _getStep: function (stepLocator) {
            var step, index = 0;
            // get step by object
            if ($.isPlainObject(stepLocator)) { // object e.g. { stepIndex: \d, optional: false }
                step = stepLocator.optional
                    ? this.optionalSteps[stepLocator.stepIndex]
                    : this.steps[stepLocator.stepIndex];
                index = stepLocator.stepIndex;
            }
                // get step by number (always this.step)
            else if (/^[0-9]+?$/.test(stepLocator)) { // numeric 
                index = stepLocator * 1;
                step = this.steps[index];
            }
            else { // string
                // get step by name
                var maxLength = this.steps.length > this.optionalSteps.length
                ? this.steps.length
                : this.optionalSteps.length;

                for (var i = 0; i < maxLength; i++) {
                    if (this.steps[i] && (this.steps[i].name === stepLocator)) {
                        step = this.steps[i];
                        index = i;
                        break;
                    }
                    if (this.optionalSteps[i] && (this.optionalSteps[i].name === stepLocator)) {
                        step = this.optionalSteps[i];
                        index = i;
                        break;
                    }
                }
            }

            // update wizard index
            this.currentStep = step.optional ? step.stepIndex : index;
            this.currentStepIsOptional = step.optional;

            return step;
        },
        _handleLoadError: function (resText, textStatus) {
            if (textStatus === 'error') {
                // this._movePrev(); // we didnt really move forward because the view could not load
                this.load('error');
                this.exception(resText);
                return true;
            }
        },
        // helpers
        _movePrev: function () {
            return --this.currentStep;
        },
        _moveNext: function () {
            return ++this.currentStep;
        }
    };

    return function (config) {
        return this.each(function () {
            $(this).data('wizard', new Wizard(this, config));
        });
    };
})();

jQuery.validator.addMethod("zipcode", function (postalcode, element) {
    return this.optional(element) || postalcode.match(/(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnpstvxy]{1}\d{1}[A-Za-z]{1} ?\d{1}[A-Za-z]{1}\d{1})$/);
}, Alkami.Localization.SiteText.RegistrationValidationEnterValidZipcode);

jQuery.validator.addMethod("taxid", function (taxid, element) {
    var numDigits = $("#num_digits").val();
    var minNumDigits = $('#min_num_digits').val();
    //var expression = "^\\d{" + numDigits + "}$"; 
    //^[0-9]{4,9}$
    var expression = "^[0-9]{" + minNumDigits + "," + numDigits + "}$";
    // This expression ensures the entry is a number with length between the minNumDigits and numDigits
    return this.optional(element) || taxid.match(new RegExp(expression));

}, Alkami.Localization.SiteText.RegistrationValidationEnterValidSSN);

jQuery.validator.addMethod("ein", function (taxid, element) {
    var numDigits = $("#num_digits").val();
    var minNumDigits = $('#min_num_digits').val();
    //var expression = "^\\d{" + numDigits + "}$"; 
    //^[0-9]{4,9}$
    var expression = "^[0-9]{" + minNumDigits + "," + numDigits + "}$";
    // This expression ensures the entry is a number with length between the minNumDigits and numDigits
    return this.optional(element) || taxid.match(new RegExp(expression));

}, Alkami.Localization.SiteText.RegistrationValidationEnterValidEIN);

jQuery.validator.addMethod("homephone", function (phone_number, element) {
    phone_number = phone_number.replace(/\s+/g, "");
    return this.optional(element) || phone_number.length > 9 && phone_number.match(/^([\(]{1}[0-9]{3}[\)]{1}[\.| |\-]{0,1}|^[0-9]{3}[\.|\-| ]?)?[0-9]{3}(\.|\-| )?[0-9]{4}$/);
}, Alkami.Localization.SiteText.RegistrationValidationEnterValidNumber);

(function (jQuery) {

    var toString = Object.prototype.toString,
        hasOwnProp = Object.prototype.hasOwnProperty;

    jQuery.isObject = function (obj) {
        if (toString.call(obj) !== "[object Object]")
            return false;

        //own properties are iterated firstly,
        //so to speed up, we can test last one if it is not own

        var key;
        for (key in obj) {
        }

        return !key || hasOwnProp.call(obj, key);
    };

    $('#primary_widget_title').html('<h2>' + Alkami.Localization.SiteText.RegistrationOnlineBankingRegister + '</h2>');
    $('#primary_widget_title h2').after('<hr></hr>');

    $(document).on('change', 'input.iris-radio__input', function () {
        var checkedInput = $('input[name="ContactId"]:checked').val();

        if (checkedInput == "another-contact-card") {
            $('div.dontwantcontact').show();
        }
        else {
            $('div.dontwantcontact').hide();
        }

        if (checkedInput == "-1") {
            $('div.otherEmail').show();
        }
        else {
            $('div.otherEmail').hide();
        }

        $.event.trigger(
        {
            type: 'ValidationConditionChanged',
            isValid: (checkedInput != 'another-contact-card' || allowAlternateEmail)
        });
    });

    $(document).on('click', '#registerAsBusiness', function (e) {
        //load next step with isBusiness flag
        $('.wizard').data('wizard').load(1, { isBusiness: 1 });
        e.preventDefault();
    });
    $(document).on('click', '#registerAsIndividual', function (e) {
        var wizardData = $('.wizard').data('wizard');
        if (wizardData.steps[3].request == '/Registration/BusinessDetails') { // For FIs that gather Business Details, the retail path must skip this step. This only applies to FIs with CoreSupportsBusinessData = false, like ICCU
            wizardData.steps[2].callback = function () {
                wizardData.load(4);
            };
        }
        wizardData.load(1);
        //DEV-3921 Prevent IE10 from firing beforeunload event.
        //http://stackoverflow.com/questions/26405439/why-ie10-fires-beforeunload-event-when-clicking-on-anchor-element-with-javascrip
        e.preventDefault();
    });

})(jQuery);